import React from 'react';
import PropTypes from 'prop-types';
import { sentenceCase } from 'change-case';
import staticGiftCards from '../../../constants/staticGiftCards';

import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

const FilterByCategory = (props) => {
	const { currentCategory, handleFilterByCategory } = props;

	const [categories, setCategories] = React.useState([]);

	React.useEffect(() => {
		if (categories.length === 0) {
			const filteredCategories = [];

			staticGiftCards.forEach((giftCard) => {
				if (!filteredCategories.includes(giftCard.category)) {
					filteredCategories.push(giftCard.category);
				}
			});

			setCategories(filteredCategories);
		}
	}, []);

	return (
		<Stack
			m={2}
			sx={{
				px: { xs: 0, md: 1 }
			}}
		>
			<FormControl>
				<Typography variant='h3' sx={{ fontSize: '1.2rem', mb: '6px', mt: '20px' }}>
					Shop by category
				</Typography>
				<RadioGroup
					defaultValue='All'
					sx={{
						' span': {
							fontSize: { xs: '13px', md: '16px' },
							paddingRight: { xs: '1px', md: '4px' },
							color: 'black'
						},
						flexDirection: { xs: 'row', md: 'column' }
					}}
					name='radio-buttons-group'
					value={currentCategory}
					onChange={(e) => handleFilterByCategory(e.target.value)}
				>
					<FormControlLabel value='all' control={<Radio size='small' />} label='All' />
					{categories.map((category, index) => {
						const id = `radio-${category}-${index}`;
						return (
							<FormControlLabel
								key={id}
								tabIndex={0}
								value={category}
								control={<Radio size='small' id={id} />}
								label={sentenceCase(category)}
								htmlFor={id}
								sx={{
									' span': {
										fontSize: { xs: '13px', md: '16px' },
										paddingRight: { xs: '1px', md: '4px' }
									}
								}}
							/>
						);
					})}
				</RadioGroup>
			</FormControl>
		</Stack>
	);
};

FilterByCategory.propTypes = {
	currentCategory: PropTypes.string,
	handleFilterByCategory: PropTypes.func
};

export default FilterByCategory;
